import { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const motives = {
  carouselNavigationPrimary: css`
    .prev-btn {
      top: 50%;
      left: -1.5rem;

      transform: translateY(-50%);
    }

    .next-btn {
      top: 50%;
      right: -1.5rem;

      transform: translateY(-50%);
    }
  `,
  carouselNavigationSecondary: css`
    .prev-btn {
      top: 50%;
      left: 0;

      transform: translateY(-50%);

      color: ${pickColor('white')};
      border-radius: 0 0.3rem 0.3rem 0;
    }

    .next-btn {
      top: 50%;
      right: 0;

      transform: translateY(-50%);

      color: ${pickColor('white')};
      border-radius: 0.3rem 0 0 0.3rem;
    }
  `,
};

export type CarouselNavigationMotives = keyof typeof motives;

const pickMotive = (motive: CarouselNavigationMotives) => motives[motive];

export { pickMotive };
